import { Injectable } from '@angular/core';
import { Color } from 'cesium';
import { SimplePolygonMapEntity } from './simple-polygon-map-entity.service';
import { PolylineMapEntity } from './polyline-map-entity.service';
import { DataContextService } from './data-context.service';
import { CameraService } from './camera.service';
import { CoreService } from './core.service';
import { WindowService } from './window.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TimelineService } from './timeline.service';

export class MedLowGeometryMapEntity extends SimplePolygonMapEntity {
  public eventId: string;
  public outline: PolylineMapEntity;
  private parentIncident: any;

  constructor(
    id: string,
    coordinates: [number, number][],
    date: string,
    color: Color,
    dataContext: DataContextService,
    cameraService: CameraService,
    coreService: CoreService,
    windowService: WindowService,
    modalService: NgbModal,
    timelineService: TimelineService
  ) {
    super('','', cameraService,coreService,windowService,dataContext,modalService,timelineService);
    this.init('Incident Geometry', 'ArcAngel//Incidents', coordinates);
    this.setShowInLayersUI(false);
    this.eventId = id;
    this.setMaterial(color.withAlpha(0));
    this.setOutline(color);
    this.setShowOutline(true);
    this.setOutlineWidth(3.0);
    this.setTimestamp(date);
    this.timestamp = undefined as any;

    // Create outline polyline
    
    this.outline = new PolylineMapEntity(
      '',
      '',
      cameraService,coreService,
      coordinates,
      color,
      3.0,
      windowService,
       dataContext,
      modalService,
      this.timelineService
    );
    this.outline.setTimestamp(date);
    this.outline.timestamp = undefined as any;
    this.outline.setShowInLayersUI(false);
    this.addOutline();
    // No setShowInOverlappingEntitiesUI on this, so skip
  }

  // Helper for centroid calculation (since center is private in base)
  private static calcCenter(locations: [number, number][]): [number, number] | undefined {
    if (!locations || locations.length === 0) return undefined;
    let latSum = 0, lonSum = 0;
    for (const [lat, lon] of locations) {
      latSum += lat;
      lonSum += lon;
    }
    return [latSum / locations.length, lonSum / locations.length];
  }

  // Override setCoordinates to update both polygon and outline
  override setCoordinates(locations: [number, number][]): void {
    // Use the base class's public/protected API to update coordinates
    // If base class has a setCoordinates, call it; otherwise, re-init
    this.init(this.name, this.layerPath, locations);
    const centerLocations = MedLowGeometryMapEntity.calcCenter(locations);
    if (centerLocations && centerLocations.length === 2) {
      this.setCenterLatitude(centerLocations[0]);
      this.setCenterLongitude(centerLocations[1]);
    }
    // If cesiumEntity exists, rebuild hierarchy
    if (this.cesiumEntity?.polygon && (this as any).setHierarchy) {
      (this as any).setHierarchy();
    } else if (this.cesiumEntity?.polygon) {
      // fallback: rebuild entity
      this.buildEntity();
    }
    this.outline.setCoordinates(locations);
  }

  setParent(parentIncident: any): void {
    this.parentIncident = parentIncident;
    this.outline.setWindowId(this.getWindowId());
  }

  getParent(): any {
    return this.parentIncident;
  }

  override getWindowId(): string {
    // If parentIncident has getWindowId, use it; else fallback to base
    if (this.parentIncident && typeof this.parentIncident.getWindowId === 'function') {
      return this.parentIncident.getWindowId();
    }
    // fallback: use windowId from base
    return (this as any).windowId || '';
  }

  override viewDetailsWindow(scope?: any, positioning?: any, autoSize?: any, closeCallBack?: any, windowShape?: any): void {
    if (this.parentIncident && typeof this.parentIncident.viewDetailsWindow === 'function') {
      this.parentIncident.viewDetailsWindow(scope, positioning, autoSize, closeCallBack, windowShape);
    }
  }

  addOutline(): void {
    this.dataContext.addMapEntity(this.outline);
  }

  override setAddedToMap(status: boolean): void {
    super.setAddedToMap(status);
    if (this.outline) {
      if (status && !this.outline.getIsAddedMap()) {
        this.dataContext.addMapEntity(this.outline);
      } else if (!status && this.outline.getIsAddedMap()) {
        this.dataContext.removeMapEntity(this.outline);
      }
    }
  }
}
